import { connect } from 'react-redux';
import Header from './header.component';

const mapStateToProps = ({ app }) => ({
  tabs: app?.config?.tabs ?? [],
  authType: app?.config?.authType,
});

export default connect(mapStateToProps)(Header);
